const onLinkIsClicked = () => {
  window.open("https://minhaclaro.claro.com.br/", "_blank");
};

export { onLinkIsClicked };
